<template>
  <div class="activity-warp">
    <div class="activity-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
      <div class="activity-title">已购套餐</div>
    </div>
    <div class="device-select" style="display: flex;font-family: MyFont7">
      <label>{{mifisn}}</label>
      <div style="text-align: right;width: 100%;" >
        <label style="background: #BDBDBD;border-radius: 22px;padding: 5px 10px;color: white;font-size: 10pt;font-family: MyFont8">{{cardOneRealStatus}}</label>
      </div>
    </div>
    <div>
      <van-tabs v-model="activeName" title-active-color="#1EBE86" color="#1EBE86" @click="tabClick">
        <van-tab name="all" title="全部" />
        <van-tab name="unPaid" title="未支付" />
        <van-tab name="paid" title="已支付" />
      </van-tabs>
    </div>
    <div style="margin: 50px 10px 0 10px" v-if="orderList.length == 0">
      <van-image :src="require('assets/imgs/result_list.png')"></van-image>
    </div>
    <div style="margin: 10px;background: white;padding: 10px;border-radius: 10px;" v-for="(item,index) in orderList" :key="index">
      <div style="display: flex;font-family: MyFont6;font-size: 13pt">
        <div style="width: 50%;">
          <label>流量套餐</label>
        </div>
        <div style="text-align: right;width: 50%;">
          <label v-if="item.status == -1" style="color: #D1D1D1;">已取消</label>
          <label v-if="item.status == 0" style="color: #FF1919;">待支付</label>
          <label v-if="item.status == 4" style="color: #D1D1D1;">已付款</label>
        </div>
      </div>
      <div style="display: flex;font-family: MyFont6;width: 100%">
        <div style="width: 30%">
          <van-image :src="item.thumbImg" width="80px" height="80px"></van-image>
        </div>
        <div style="width: 70%">
          <div style="color: #333333;font-size: 13pt;">
            <label>{{item.productName}}</label>
          </div>
          <div style="color: #999999;padding: 5px 0 10px 0">
            <label>{{item.totalRemain}}GB</label>
          </div>
          <div style="display: flex;width: 100%">
            <div style="width: 40%"><label>x{{item.buyCount}}</label></div>
            <div v-if="item.status === 4" style="width: 60%;text-align: right;color: #FF1919;font-size: 13pt">￥{{parseFloat(item.payPrice).toFixed(2)}}元</div>
            <div v-if="item.status === 0 || item.status === -1" style="width: 60%;text-align: right;color: #FF1919;font-size: 13pt">￥{{parseFloat(item.totalPrice).toFixed(2)}}元</div>
          </div>
        </div>
      </div>
      <div style="font-family: MyFont8;">
        <div style="display: flex;margin: 10px 0">
          <div style="color: #999999;width: 35%">
            <label>有效期:</label>
          </div>
          <div style="color: #333333;width: 65%;text-align: right">jsapi
            <label>{{item.startTime}}至{{item.endTime}}</label>
          </div>
        </div>
        <div style="display: flex;margin: 10px 0">
          <div style="color: #999999;width: 35%">
            <label>下单时间:</label>
          </div>
          <div style="color: #333333;width: 65%;text-align: right">
            <label>{{item.addTime}}</label>
          </div>
        </div>
        <div style="display: flex;margin: 10px 0">
          <div style="color: #999999;width: 35%">
            <label>订单金额:</label>
          </div>
          <div style="color: #333333;width: 65%;text-align: right">
            <label v-if="item.status === 4">￥{{parseFloat(item.payPrice).toFixed(2)}}元</label>
            <label v-if="item.status === 0 || item.status === -1 ">￥{{parseFloat(item.totalPrice).toFixed(2)}}元</label>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <div style="width: 50%" v-if="item.status == 0">
          <van-button @click="toCancel(item)" style="color:#1EBE86;border: 1px solid #1EBE86;border-radius: 20px;width: 150px;height: 40px;">取消订单</van-button>
        </div>
        <div style="text-align: right;width: 50%" v-if="item.status == 0">
          <van-button @click="payClick(item)" style="color:white;border: 1px solid #1EBE86;border-radius: 20px;width: 150px;background:#1EBE86;height: 40px; ">去支付</van-button>
        </div>
      </div>
    </div>
    <div style="width: 100%;text-align: center;padding-bottom: 30px;" :style="orderList.length == 0 ? 'position: absolute;bottom: 0px' : ''">
      <div style="display: inline-flex;width: 70%;margin-top: 20px;">
        <div style="width: 50%;text-align: left;display: flex">
          <van-image class="backgroud-img" :src="require('assets/imgs/mifi07.png')" width="30px" height="30px"></van-image>
          <div style="color: #1EBE86;margin: 5px 0 0 5px;font-family: MyFont8">关注公众号</div>
        </div>
        <div style="width: 50%;">
          <div style="display: flex;justify-content: right">
            <van-image :src="require('assets/imgs/mifi10.png')" width="22px" height="22px" style="margin-top: 3px"></van-image>
            <div style="color: #1EBE86;margin: 5px 0 0 5px;font-family: MyFont8" @click="backHome()">返回首页</div>
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet v-model="buyShow" style="background: #f2f2f2">
      <div>
        <div style="display: flex;margin: 0 20px 0 20px;padding: 10px; background: white;border-radius: 15px">
          <div style="width: 30%">
            <van-image :src="appUrl+pkgItem.thumbImg" width="88px" height="88px"></van-image>
          </div>
          <div style="margin-left: 10px;width: 70%">
            <div style="font-size: 13pt;font-weight: bold">{{pkgItem.productName}}</div>
            <div style="padding: 10px 0 15px 0;color:#1EBE86;font-size: 9pt">AI智能加速套餐</div>
            <div style="display: flex">
              <div style="color: #FF1919;width: 40%">
                <label style="font-size: 8pt">￥</label>
                <label style="font-size: 14pt">{{parseFloat(pkgItem.totalPrice).toFixed(2)}}</label>
              </div>
            </div>
          </div>
        </div>
        <div style="margin: 10px 20px 0 20px;padding: 10px; background: white;border-radius: 15px">
          <div style="display: flex;width: 100%;padding: 10px 0 10px 0">
            <div style="width: 50%">
              <label>商品金额：</label>
            </div>
            <div style="width: 50%;text-align: right">
              <label>￥{{parseFloat(pkgItem.totalPrice).toFixed(2)}}元</label>
            </div>
          </div>
          <div style="padding: 15px 0;border-top: 1px solid #e8e6e6">
            <van-radio-group v-model="paymentType" checked-color="#1EBE86">
              <div style="display: flex">
                <div style="width: 50%;display: flex">
                  <div style="padding-right: 10px">
                    <van-image :src="require('assets/imgs/mifi12.png')" width="20px" height="20px"></van-image>
                  </div>
                  <div >微信支付</div>
                </div>
                <div style="width: 50%;">
                  <van-radio name="0" style="justify-content: right"></van-radio>
                </div>
              </div>
              <div style="display: flex;padding: 15px 0 0px 0">
                <div style="width: 50%;display: flex">
                  <div style="padding-right: 10px">
                    <van-image :src="require('assets/imgs/mifi13.png')" width="20px" height="20px"></van-image>
                  </div>
                  <div>余额支付</div>
                </div>
                <div style="width: 50%">
                  <van-radio name="1" style="justify-content: right"></van-radio>
                </div>
              </div>
            </van-radio-group>
          </div>
        </div>
        <div style="margin: 10px 20px 20px 20px;padding: 10px; display: flex">
          <div style="color: #FF1919;font-size: 13pt;width: 60%;margin-top: 10px">
            <label style="font-size: 8pt">￥</label>
            <label>{{parseFloat(pkgItem.totalPrice).toFixed(2)}}</label>
            <label style="font-size: 8pt">元</label>
          </div>
          <div style="width: 40%;text-align: right">
            <van-button type="info" style="border-radius: 18px;width: 80px;font-family: MyFont7" @click="toPay">去支付</van-button>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { ORDER_LIST } from '../../apis/user'
import { mapState } from "vuex";
import { MIFI_DEVICE_INFO, MIFI_PRODUCT_CANCEL_ORDERS, MIFI_PRODUCT_ORDERS, MIFI_PRODUCT_REPAY } from "@/apis/cabinet";
export default {
  components: {
  },
  computed: {
    ...mapState(['mifisn'])
  },
  data () {
    return {
      activeName: 'all',
      orderList: [],
      pkgItem: {},
      appUrl: `${process.env.VUE_APP_Domain}`,
      buyShow: false,
      productCount: 1,
      paymentType: '0',
      cardOneRealStatus: '未实名'
    }
  },
  methods: {
    tabClick() {
      this.orderList = []
      if (this.activeName === 'all') {
        this.getOrderList(null)
      } else if (this.activeName === 'unPaid') {
        this.getOrderList(0)
      } else if (this.activeName === 'paid') {
        this.getOrderList(4)
      }
    },
    deviceInfoById(devId) {
      this.$post(
        MIFI_DEVICE_INFO, {
          devId: devId
        }, (resp) => {
          if (resp.data) {
            if (resp.data.data.online === 0) {
              this.cardOneRealStatus = '离线'
            } else if (resp.data.data.online === 1) {
              this.cardOneRealStatus = '在线'
            } else if (resp.data.data.online === 3) {
              this.cardOneRealStatus = '已拿卡'
            } else if (resp.data.data.online === 4) {
              this.cardOneRealStatus = '拿卡失败'
            } else if (resp.data.data.online === 5) {
              this.cardOneRealStatus = '正在拨号'
            } else if (resp.data.data.online === 6) {
              this.cardOneRealStatus = '下线'
            } else if (resp.data.data.online === 6) {
              this.cardOneRealStatus = '本地卡在线'
            }
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    getOrderList(status) {
      this.$loading(true)
      this.$post(
        MIFI_PRODUCT_ORDERS, {
          devId: this.mifisn,
          status: status
        }, (resp) => {
          this.$loading(false)
          this.orderList = resp.data
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    payClick(item) {
      this.pkgItem = item
      this.buyShow = true
    },
    toPay() {
      var $this = this
      this.$loading(true)
      this.$post(
        MIFI_PRODUCT_REPAY, {
          orderId: this.pkgItem.orderId,
          paymentType: this.paymentType
        }, (resp) => {
          /* eslint-disable */
          if (this.paymentType == 0) {
            WeixinJSBridge.invoke('getBrandWCPayRequest', {
                "appId": resp.data.appId,
                "timeStamp": resp.data.timeStamp,
                "nonceStr": resp.data.nonceStr,
                "package": resp.data.packageValue,
                "signType": 'MD5',
                "paySign": resp.data.paySign
              },
              function (res) {
                if (res.err_msg === "get_brand_wcpay_request:ok") {
                  $this.$loading(false)
                  $this.getOrderList(null)
                  $this.buyShow = false
                } else if (res.err_msg === "get_brand_wcpay_request:fail") {
                  $this.$toast("失败")
                  $this.$loading(false)
                }
              });
          }else if (this.paymentType == 1) {
            $this.$loading(false)
            $this.getOrderList(null)
            $this.buyShow = false
          }
          /* eslint-disable */
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    toCancel(item) {
      this.$loading(true)
      this.$post(
        MIFI_PRODUCT_CANCEL_ORDERS, {
          orderId: item.orderId
        }, (resp) => {
          this.$loading(false)
          this.getOrderList(null)
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onBack () {
      this.$router.go(-1)
    },
    backHome() {
      this.$router.push('/')
    }
  },
  created () {
    if (this.mifisn) {
      this.getOrderList(null)
      this.deviceInfoById(this.mifisn)
    }
  }
}
</script>

<style lang="less">
.activity-warp {
  height: 100vh;
  // background: linear-gradient(#00AB46, #1A2229);
  background: #F4F4F4;
  .activity-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .backicon {
      width: 50px;
    }
    .activity-title {
      text-align: center;
      width: 100%;
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 36px;
      color: #1A2229;
    }
  }
}
.device-select{
  text-align: left;
  border-left: 5px solid #1EBE86;
  margin-left: 20px;
  margin: 20px;
  label{
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    margin-left: 15px;
  }
}
</style>
